module.exports = __webpack_public_path__ + "static/media/bindEnterprise1.9da4f726.png";